// extracted by mini-css-extract-plugin
module.exports = {"underground-icon":"_02712f2b3b--underground-icon--bCKpx","underground-icon--regions":"_02712f2b3b--underground-icon--regions--tWbN4"};